/**
 * Partners
 */

// React
import React, {FunctionComponent, useEffect, useState, useContext} from 'react';

// Context
import AuthContext from '../../authContext';
import prtnerRepository from 'client-sdk/src/Repository/partners-repository'

// Components
import Pagination from '@material-ui/lab/Pagination';
import RenderFilter from '../../utils/listDaynamicFilterHookForm';
import List from './components/list';
import Edit from './components/edit';
import Add from './components/add';
import Detail from './components/detail';
import InventoryCom from './components/inventory';
import Can from '../../components/Can';
import Modal from '../../components/Modal';

// UI
import theme from '../../theme';
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  Grid,
  DialogTitle,
  IconButton,
  Select,
  MenuItem,
  FormControl,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiPlus,
  mdiHomePlusOutline,
  mdiAccountDetailsOutline,
  mdiPencilOutline,
  mdiCheck,
  mdiClose,
} from '@mdi/js';

// Helper
import {removeEmptyValueObject} from '../../utils/helpers';

// Type
import {Props} from './interfaces';
import type {Filter} from '../../utils/listDaynamicFilter';
import useQuery from '../../utils/hook/useQuery';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },

    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      padding: '10px 0',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      marginRight: '10px',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: 0,
      marginTop: '30px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

const Partners: FunctionComponent<Props> = (props: Props) => {
  const authContext = useContext(AuthContext);

  const [openSize, setOpenSize] = React.useState(false as boolean);

  const [filters, setFilters] = useState([] as Filter[]);
  const {filtersValues, setFiltersValues} = useQuery({
    page: 0,
    size: 10,
  } as any);
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [type, setType] = useState('edit' as string);
  const [openConfirmActive, setOpenConfirmActive] = useState(false as boolean);
  const [openDialog, setOpenDialog] = useState(false as boolean);
  const [openAdd, setOpenAdd] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [partners, setPartners] = useState([])
  const [partnersCount, setPartnersCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const removeFilterHandler = (fieldName: any) => {
    const filtered = {...filtersValues};
    delete filtered[fieldName];
    setFiltersValues(filtered);
  };

  const filterTranslator = (fieldName: string) => {
    const status = {
      name: 'نام شرکت',
      'name.equals': 'نام شرکت:',
      'name.contains': 'نام شرکت:',
      ranking: 'تعداد مراکز توزیع',
      'ranking.equals': 'تعداد مراکز توزیع',
      'ranking.contains': 'تعداد مراکز توزیع',
      'id.equals': 'شناسه شرکت:',
      'id.contains': 'شناسه شرکت:',
      phoneNumber: 'شماره تماس شرکت',
      'phoneNumber.equals': 'شماره تماس شرکت:',
      'phoneNumber.contains': 'شماره تماس شرکت:',
      workField: 'حوزه فعالیت',
      'workField.equals': 'حوزه فعالیت:',
      'workField.contains': 'حوزه فعالیت:',
      adminId: 'کاربر مرکز',
      'adminId.equals': 'کاربر مرکز:',
      'adminId.contains': 'کاربر مرکز:',
    };
    return status[fieldName];
  };

  useEffect(() => {
    getPartners();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps
  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({...filtersValues, page: page - 1});
  };

  const getPartners = async () => {
    const {page, size} = filtersValues;
    setLoading(true)
    try {
      const {response, count} = await prtnerRepository.getPartners({payload: {
        ...removeEmptyValueObject(filtersValues),
        page,
        size,
      }})
      setPartners(response.data)
      setPartnersCount(count.data)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      handleError(error)
    }
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'name.contains',
        label: 'نام شرکت',
      },
      {
        type: 'input',
        id: 'phoneNumber.contains',
        label: 'شماره تماس شرکت',
      },
      {
        type: 'number',
        id: 'id.equals',
        label: 'شناسه شرکت',
      },
    ]);
  };
  let headCells = [
    {
      id: 'name',
      label: 'نام شرکت',
      type: 'input',
    },
    {id: 'id', label: 'شناسه شرکت', type: 'input'},
    {id: 'phoneNumber', label: 'شماره تماس شرکت', type: 'input'},
    {id: 'workField', label: 'حوزه فعالیت', type: 'input'},
    {id: 'ranking', label: 'تعداد مراکز توزیع', type: 'input'},
    {id: 'adminId', label: 'کاربر مرکز', type: 'input'},
  ];
  const head = {headCells};
  const handleDisableUser = async () => {
    changePartnerStatus({
      id,
      body: 'SUSPENDED',
      pagination: filtersValues,
    });
    setOpenConfirmDisable(false);
  };
  const handleActiveUser = async () => {
    changePartnerStatus({
      id,
      body: 'ACTIVE'.replace(/'/g, '"'),
      pagination: filtersValues,
    });

    setOpenConfirmActive(false);
  };

  const handleOpenConfirmDisable = (id: number) => {
    setOpenConfirmDisable(true);
    setId(id);
  };
  const handleOpenConfirmActive = (id: number) => {
    setOpenConfirmActive(true);
    setId(id);
  };
  const handleOpen = (id: number, type: string) => {
    setType(type);
    setOpenDialog(true);
    setId(id);
  };

  const handleClose = () => {
    setOpenConfirmDisable(false);
    setOpenConfirmActive(false);
    setOpenDialog(false);
    setOpenAdd(false);
    setOpenSize(false);
  };
  const handleOpenConfirmUpdateState = (data: {id: number; body: any}) => {
    setId(data.id);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{value: unknown}>) => {
    setFiltersValues({...filtersValues, page: 0, size: event.target.value});
  };

  const updatePartner = async (body:any) => {
    try {
      await prtnerRepository.updatePartner({payload: {body}})
      handleNotfication('شرکت با موفقیت ویرایش شد.', 'success')
      getPartners();
      handleClose();
    } catch (error) {
      handleError(error)
    }
  }

  const createPartner = async (body:any) => {
    try {
      await prtnerRepository.createPartner({payload: {body}})
      handleNotfication('شرکت با موفقیت ایجاد شد.', 'success')
      getPartners();
      handleClose();
    } catch (error) {
      handleError(error)
    }
  }

  const changePartnerStatus = async (body:any) => {
    try {
      await prtnerRepository.updatePartnerStatus({payload: body})
      handleNotfication('وضعیت شرکت با موفقیت تغییر کرد', 'success')
    } catch (error) {
      handleError(error)
    }
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={6}>
        <Grid item xs={12} sm={6} alignItems="center">
          <Typography variant="h4" component="h2">
            {`لیست شرکت‌ها`}
          </Typography>
        </Grid>
        <Grid item sm={6} xs={12}>
          <RenderFilter
            filters={filters}
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                page: 0,
                size: 10,
              });
            }}
            mainFiltersCount={0}
            baseFilter={{
              type: 'input',
              id: 'name.contains',
              placeholder: 'نام شرکت',
            }}
            filterValues={filtersValues}
          />
        </Grid>
        <Grid xs={6} item container alignItems="center">
          {loading ? (
            ''
          ) : (
            <>
              <div className={classes.subtitle}>{`تعداد کل شرکت‌ها:`}</div>
              <div>
                &nbsp;
                <b>{`${partnersCount}`}</b>
              </div>
            </>
          )}
        </Grid>

        <Grid container item xs={6} direction="row-reverse">
          <Can
            role={authContext.user.role}
            perform="partners:createNewPartner"
            yes={() => (
              <Button
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<Icon path={mdiPlus} size={1} />}
                onClick={() => setOpenAdd(true)}
              >{`ایجاد شرکت جدید`}</Button>
            )}
          />
        </Grid>

        <Grid item xs={12}>
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <List
                data={partners}
                handleOpenConfirmDisable={handleOpenConfirmDisable}
                handleOpenConfirmActive={handleOpenConfirmActive}
                handleOpen={handleOpen}
                changeStatus={handleOpenConfirmUpdateState}
                head={head}
                filterVal={filtersValues}
                onFilterValue={(filtervalues: any) => {
                  setFiltersValues({
                    ...removeEmptyValueObject(filtervalues),
                    ...filtersValues,
                    page: 0,
                    size: 10,
                  });
                }}
                removeFilterHandler={removeFilterHandler}
                filterLabelTranslator={filterTranslator}
              />
            </>
          )}
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
              {' '}
              تعداد نمایش در هر صفحه:
            </div>
            <Select
              open={openSize}
              onClose={handleClose}
              onOpen={() => setOpenSize(true)}
              value={filtersValues.size}
              onChange={handleChangeSizePage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          <Pagination
            className={classes.pagination}
            count={Math.ceil(partnersCount / filtersValues.size)}
            color="secondary"
            page={filtersValues.page + 1}
            onChange={handleChangePage}
          />
        </Grid>
      </Grid>
      <Dialog
        fullWidth
        open={openConfirmDisable || openConfirmActive}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div
            className={
              openConfirmDisable ? classes.cancelIcon : classes.editIcon
            }
          >
            {openConfirmDisable ? (
              <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
            ) : (
              <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
            )}
          </div>
          <div className={classes.cancelTitle}>
            {` آیا از 
          
          ${openConfirmDisable ? 'غیر' : ''}
          
          فعال کردن شرکت با نام
          "${partners?.find(user => user.id === id)?.name}"
          اطمینان دارید؟`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {`خیر`}
              </Button>
            </Grid>
            <Grid item xs={4}>
              {openConfirmDisable ? (
                <Button
                  onClick={handleDisableUser}
                  fullWidth
                  variant="contained"
                  size="large"
                >
                  {`بله`}
                </Button>
              ) : (
                <Button
                  onClick={handleActiveUser}
                  fullWidth
                  variant="contained"
                  size="large"
                >
                  {`بله`}
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Modal
        maxWidth="md"
        onClose={handleClose}
        open={openDialog}
        maxWidth="lg"
        title={
          <div className={classes.editIcon}>
            {type === 'detail' && (
              <Icon path={mdiAccountDetailsOutline} size={4} />
            )}

            {type === 'edit' && (
              <Icon
                path={mdiPencilOutline}
                size={4}
                color={theme.palette.blue.main}
              />
            )}
          </div>
        }
        content={
          <>
            {type === 'edit' && (
              <Edit
                onClose={handleClose}
                data={partners?.find(partner => partner.id === id)}
                update={updatePartner}
              />
            )}
            {type === 'detail' && (
              <Detail
                data={partners?.find(partner => partner.id === id)}
              />
            )}

            {type === 'inventory' && (
              <InventoryCom
                data={partners?.find(
                  (partner: any) => partner.id === id
                )}
              />
            )}
          </>
        }
      />

      <Modal
        maxWidth="md"
        onClose={handleClose}
        open={openAdd}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiHomePlusOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <Add
            onClose={handleClose}
            create={createPartner}
          />
        }
      />
    </div>
  );
};

export default Partners;
